<template>
  <div>
    <v-btn icon @click="dialog_ativo = ! dialog_ativo">
      <v-icon>mdi-plus-box-multiple</v-icon>
    </v-btn>

    <SysDialog v-model="dialog_ativo" txt-botao="confirmar" @click:primary="consolidarPedidos()">
      <template #titulo>
        <div>
          <p class="ma-0">Consolidar carrinhos</p>
          <p class="ma-0 mt-n3 font-12 font-weight-regular text-gray-800">Selecione os fornecedores para análise em apenas um carrinho</p>
        </div>

        <v-spacer />

        <v-btn icon @click="dialog_ativo = ! dialog_ativo">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>

      <div v-if="fornecedores.length === 0" class="d-flex align-center justify-center">
        <div class="text-center py-10">
          <v-progress-circular
            indeterminate
            color="red"
            width="3"
            size="50"
          />

          <p class="ma-0 pt-2">Carregando... aguarde</p>
        </div>
      </div>

      <div v-else class="mt-n4">
        <v-data-table
          v-model="fornecedores_selecionados"
          :headers="cabecalhos"
          :items="fornecedores"
          item-key="id"
          hide-default-footer
          fixed-header
          show-select
          :items-per-page="-1"
          :height="fornecedores.length > 8 ? '400px' : undefined"
        />
      </div>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import {buscarFornecedoresPedido, consolidarPedidos} from "@/api/compraPorProdutosGerais/Carrinho";
import {logout} from "@/helpers";

export default {
  name: "ConsolidaPedidos",
  components: {
    SysDialog
  },
  props: {
    pedido_selecionado: Object
  },
  data: () => ({
    dialog_ativo: false,
    fornecedores_selecionados: [],
    fornecedores: [],
    cabecalhos: [
      {text: 'Id', value: 'id'},
      {text: 'Nome fornecedor', value: 'nome_fornecedor'},
    ]
  }),
  computed:{
    FORNECEDORES_PARA_DESCONSOLIDAR() {
      const callback = item => this.fornecedores_selecionados.every(sub_item => sub_item.id !== item.id);
      return this.fornecedores.filter(callback);
    },
    CALLBACK_ATUALIZAR_CARRINHO() {
      return this.$store.getters["CompraProdutosGerais/callbackRecarregarPedidosCompraCarrinho"];
    }
  },
  watch: {
    dialog_ativo() {
      if (this.fornecedores.length === 0) {
        this.buscarFornecedores();
      }
    },
    pedido_selecionado() {
      this.fornecedores = [];
    }
  },
  methods: {
    buscarFornecedores() {
      buscarFornecedoresPedido(this.pedido_selecionado.idpedido)
        .then(fornecedores => {
          this.fornecedores = fornecedores;
          this.fornecedores_selecionados = fornecedores.filter(item => item.consolidado);
        })
        .catch(logout)
    },
    consolidarPedidos() {
      const parametros = {
        grupo: this.pedido_selecionado.grupo,
        filial: this.pedido_selecionado.filial,
        consolidar: this.Helpers.arrayColumn(this.fornecedores_selecionados, 'id'),
        desconsolidar: this.Helpers.arrayColumn(this.FORNECEDORES_PARA_DESCONSOLIDAR, 'id'),
      };

      this.$store.dispatch("loading/addRequisicao",
        consolidarPedidos(parametros)
          .then(() => {
            this.dialog_ativo = false;
            this.CALLBACK_ATUALIZAR_CARRINHO();
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
